import styled from 'styled-components';

export const SocialMediaIcons = styled.div`
  display: flex;
  margin-top: 1rem;
`;

export const SocialMediaIcon = styled.a`
  display: inline-block;
  margin: 0 1rem;
  font-size: 1.5rem;
  color: ${({ theme }) => theme.text_primary};
  transition: color 0.2s ease-in-out;
  &:hover {
    color: ${({ theme }) => theme.primary};
  }
`;

export const SubTitle = styled.div`
  font-size: 20px;
  line-height: 32px;
  margin-right: 150px;
  margin-left: 150px;
  margin-bottom: 20px; /* Adjusted margin for spacing */
  color: ${({ theme }) => theme.text_secondary};

  @media (max-width: 640px) {
    font-size: 18px;
    line-height: 28px;
    margin-right: 20px;
    margin-left: 20px;
    text-align: justify;
    margin-bottom: 40px;
    text-justify: inter-word; 
  }
`;

export const Register = styled.div`
  
  text-decoration: none;
  
  margin-top: 20px;
  max-width: 300px;
  text-align: center;
  padding: 16px;
  color: ${({ theme }) => theme.white};
  border-radius: 30px;
  cursor: pointer;
  font-size: 20px;
  font-weight: 600;
  transition: all 0.3s ease-in-out !important;
  
  background: linear-gradient(145deg, #00b4db 0%, #0083b0 100%);
  background: -moz-linear-gradient(145deg, #00b4db 0%, #0083b0 100%);
  background: -webkit-linear-gradient(145deg, #00b4db 0%, #0083b0 100%);
  
  box-shadow: 5px 5px 15px rgba(0, 0, 0, 0.2),
              -5px -5px 15px rgba(255, 255, 255, 0.1);
  
  &:hover {
    transform: scale(1.02);
    box-shadow: 10px 10px 20px rgba(0, 0, 0, 0.4),
                -10px -10px 20px rgba(255, 255, 255, 0.2);
    filter: brightness(1.1);
  }

  @media (max-width: 640px) {
    padding: 14px 0;
    font-size: 18px;
  }
`;
